import { LoadingParams, ListResponse } from 'framework/list';
import type { ApiRequestOptions } from 'framework/api';
import { usePeopleManagementApi } from 'infrastructure/api';
import { PositionProfileTimelineEvent, PositionProfileTimelineNoteValues } from './types';

const RESOURCE_URL = '/position-profiles';

const usePositionProfileTimelineService = () => {
  const { sendPostRequest } = usePeopleManagementApi();

  const getTimeline = async (
    id: string,
    { pageNumber, pageSize, filter = {}, sort }: LoadingParams = { pageNumber: 0, pageSize: 50 },
    options?: ApiRequestOptions,
  ): Promise<ListResponse<PositionProfileTimelineEvent>> => {
    const response = await sendPostRequest(
      `${RESOURCE_URL}/${id}/timeline/search`,
      {
        pageNumber,
        pageSize,
        filter,
        sort,
      },
      options,
    );

    return response.json();
  };

  const getTimelinePageById = async (
    id: string,
    timelineEntryId: string,
    { pageNumber, pageSize, filter = {}, sort }: LoadingParams = { pageNumber: 0, pageSize: 50 },
    options?: ApiRequestOptions,
  ): Promise<ListResponse<PositionProfileTimelineEvent>> => {
    const response = await sendPostRequest(
      `${RESOURCE_URL}/${id}/timeline/${timelineEntryId}`,
      {
        pageNumber,
        pageSize,
        filter,
        sort,
      },
      options,
    );

    return response.json();
  };

  const createTimelineNote = async (
    id: string,
    values: PositionProfileTimelineNoteValues,
  ): Promise<PositionProfileTimelineEvent> => {
    const response = await sendPostRequest(`${RESOURCE_URL}/${id}/timeline`, {
      note: values.note.trim(),
    });

    return response.json();
  };

  return {
    getTimeline,
    getTimelinePageById,
    createTimelineNote,
  };
};

export default usePositionProfileTimelineService;
